/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Support_Internalquestions_Body_01Inputs */

const en_settings_support_internalquestions_body_01 = /** @type {(inputs: Settings_Support_Internalquestions_Body_01Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For any issue that would likely require an internal review, please reach out to`)
};

/**
* | output |
* | --- |
* | "For any issue that would likely require an internal review, please reach out to" |
*
* @param {Settings_Support_Internalquestions_Body_01Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_support_internalquestions_body_01 = /** @type {((inputs?: Settings_Support_Internalquestions_Body_01Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Internalquestions_Body_01Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_support_internalquestions_body_01(inputs)
});
export { settings_support_internalquestions_body_01 as "settings_support_internalQuestions_body_0" }